export enum MasterSolutionEnums {
  //Estados
  open = 1,
  closed = 2
}